/**
 * Embedded forms functions.
 */

/**
 * Hook the progress bar iteration on the buttons.
 */
function addClickListenerToButtons() {
	const nextButtons = document.querySelectorAll( '.wfPageNextButton' );
	const previousButtons = document.querySelectorAll( '.wfPagePreviousButton' );

	nextButtons.forEach( ( nextButton ) => {
		nextButton.addEventListener( 'click', function () {
			setCurrentItemInProgressBar( nextButton.getAttribute( 'wfpageindex_activate' ) );
		} );
	} );

	previousButtons.forEach( ( previousButton ) => {
		previousButton.addEventListener( 'click', function () {
			setCurrentItemInProgressBar( previousButton.getAttribute( 'wfpageindex_activate' ) );
		} );
	} );
}

/**
 * Changes the class name of the progress bar to indicate the current
 * step, e.g. 'Step1', 'Step2' and so on.
 *
 * @param {number} step Step number.
 */
const setCurrentItemInProgressBar = ( step ) => {
	const progressBar = document.getElementById( 'progress_bar' );

	if ( ! progressBar ) {
		return;
	}

	progressBar.removeAttribute( 'class' );
	progressBar.classList.add( 'Step' + step );
};

/**
 * Implements a MutationObserver API.
 *
 * @param {string} selector element selector.
 * @returns {HTMLElement} DOM element.
 */
function waitForElm( selector ) {
	return new Promise( resolve => {
		if ( document.querySelector( selector ) ) {
			return resolve( document.querySelector( selector ) );
		}

		const observer = new MutationObserver( mutations => {
			if ( document.querySelector( selector ) ) {
				resolve( document.querySelector( selector ) );
				observer.disconnect();
			}
		} );

		observer.observe( document.body, {
			childList: true,
			subtree: true,
		} );
	} );
}

// Add listeners to buttons once the form is loaded.

window.addEventListener( 'load', () => {
	waitForElm( '#progress_bar' ).then( ( elm ) => {
		addClickListenerToButtons();
	} );
} );
